"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const ArrowForwardIosRounded_1 = require("@mui/icons-material/ArrowForwardIosRounded");
const merge_1 = require("merge");
const Typography_1 = require("../Typography");
const label_btn_styles_1 = require("./label-btn.styles");
function LabelBtn(_a) {
    var { text, endIcon, typographyMode, sx, children, qaIds } = _a, rest = __rest(_a, ["text", "endIcon", "typographyMode", "sx", "children", "qaIds"]);
    const styles = (0, label_btn_styles_1.default)();
    return ((0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({ variant: "outlined", endIcon: endIcon !== null && endIcon !== void 0 ? endIcon : (0, jsx_runtime_1.jsx)(ArrowForwardIosRounded_1.default, {}), sx: merge_1.default.recursive(styles.btn, sx), "data-qa-id": qaIds === null || qaIds === void 0 ? void 0 : qaIds.btnId }, rest, { children: children !== null && children !== void 0 ? children : ((0, jsx_runtime_1.jsx)(Typography_1.default, { typo: typographyMode || 'button', sx: styles.text, "data-qa-id": qaIds === null || qaIds === void 0 ? void 0 : qaIds.textId, children: text })) })));
}
exports.default = LabelBtn;
